//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, FormContext } from "react-hook-form";

import { addAnswers, modalSteps, stepPosition } from "../../Store/simulate/actions";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";

import BreadCrumbs from "../BreadCrumbs";
import ModalSteps from "./FormElements/ModalSteps";
import Quiz from "./FormElements/quiz";
import Button from "../../Components/FormElements/Button";
import FormTitle from "../../Components/FormElements/FormTitle";
import NavCase from "../../Components/FormElements/NavCase";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import Footer from "../../Components/Footer";


import { Answers, RootState } from "../../interfaces/additionalInfo";
import { RootQuiz } from "../../interfaces/quiz";

import IconBack from "../../Resources/svg/Icons/IconBack";
import TabTitle from "../../Components/tabTitle";
import { ContractorForm, InsuredForm } from "../../Components/stepperComponents/dueDiligence";

export const AdditionalInfoPart2 = () => {
  const dataStoreClient = useSelector((state: RootState) => state.simulate.policy.client);
  const dataStoreAnswers = useSelector((state: any) => state.simulate.policy.answers);
  const [loadingClick, setLoadingClick] = useState(false);
  const client = useSelector((state: RootState) => state.simulate.policy.client);
  const [enableButton, setEnableButton] = useState(true);
  const dataClient = client.datosCliente;
  const history = useHistory();
  const dispatch = useDispatch();
  
  let dataRedux;

  let above50k;
  if(Object.entries(dataStoreClient.acumuladoOrigenesFondo).length !== 0){
    above50k = dataStoreClient.acumuladoOrigenesFondo.isAbove50k;
  }

  const { asegurado, contratante } = dataStoreClient;

  const [ activeTab, setActiveTab ] = useState('insured');

  const [formInsuredValid, setFormInsuredValid] = useState<bolean | null>(false);
  const [formContractorValid, setFormContractorValid] = useState<boolean | null>(false);

  const CONTRACTOR_EQUAL_INSURED = Object.keys(contratante).length === 0;
  const CONTRACTOR_DIFF_INSURED = Object.keys(contratante).length !== 0;

  const [validOptionalValues, setValidOptionalValues] = useState(true);

  const onSubmit = (values: object, profileType: string) => {
    setLoadingClick(true);

    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined && value !== null && value !== "")
    );
    dispatch(addAnswers(filteredValues));
    
    if(profileType === 'INSURED'){
      if(CONTRACTOR_EQUAL_INSURED){
        setTimeout(() => {
          setEnableButton(false);
          dispatch(stepPosition(7));
          history.push("/cotizaciones/verificacion-simulacion");
          setLoadingClick(false);
        }, 500);
      } else if(CONTRACTOR_DIFF_INSURED){
        setActiveTab('contractor');
        setLoadingClick(false);
        window.scrollTo(0, 0);
      }
    } else{
      setTimeout(() => {
        setEnableButton(false);
        dispatch(stepPosition(7));
        history.push("/cotizaciones/verificacion-simulacion");
        setLoadingClick(false);
      }, 500);
    }   
  };

  useBeforeFirstRender(dataClient);

  useEffect(() => {
    dispatch(stepPosition(6));
    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:datos-adicionales",
      },
      event: "trackVirtual",
    });
  }, []);

  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  return (
    <>
      <div className="wrap">
        <NavResponsive position={6} title="Datos adicionales"/>
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Datos adicionales</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            
            { CONTRACTOR_DIFF_INSURED && <div className="detailsTab__tabs-maxwidth">
              <TabTitle id={'Asegurado'} onClick={(e: any) => dataRedux ?  setActiveTab('insured') : false } defaultChecked={ activeTab === 'insured' ? true : null} disabled={true} />
              <TabTitle id={'Contratante'} onClick={(e: any) => dataRedux ?  setActiveTab('contractor') : false } defaultChecked={ activeTab === 'contractor' ? true : null} disabled={true} />
            </div> }
            {activeTab === 'insured' && <InsuredForm setFormInsuredValid={setFormInsuredValid} loading={loadingClick} onSubmit={(values: any) => onSubmit(values, 'INSURED')} validOptionalValues={validOptionalValues} setValidOptionalValues={setValidOptionalValues} />}
            {activeTab === 'contractor' && <ContractorForm setFormContractorValid={setFormContractorValid} loading={loadingClick} onSubmit={(values: any) => onSubmit(values, 'CONTRACTOR')} validOptionalValues={validOptionalValues} setValidOptionalValues={setValidOptionalValues} />}
          </div>
        </div>
      </div>
      <ModalSteps />
      <Footer />
    </>
  );
};
